var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSymbolNew = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M8 15.197H4a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1m-4-2a3 3 0 0 0-3 3v4a3 3 0 0 0 3 3h4a3 3 0 0 0 3-3v-4a3 3 0 0 0-3-3zM15 18.197a3 3 0 1 0 6 0 3 3 0 0 0-6 0m3-5a5 5 0 1 0 0 10 5 5 0 0 0 0-10M9.336 1.89a2 2 0 0 1 3.328 0l4.132 6.198c.886 1.329-.067 3.11-1.664 3.11H6.869c-1.598 0-2.55-1.781-1.665-3.11zM11 3 6.869 9.197h8.263z",
  clipRule: "evenodd"
})));
export default SvgSymbolNew;